let isLoading = false;
let activeObservers = [];

const loadItems = async (button) => {
  if (isLoading) return;
  isLoading = true;

  const totalPages = parseInt(document.querySelector('[data-total-pages]')?.value);
  let currentPage = parseInt(document.querySelector('[data-current-page]')?.value);
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const rawValue = document.querySelector("[data-next-url]").value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);
  document.querySelectorAll('[data-current-page]').forEach(el => { el.value = currentPage; });

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  try {
    const _lmResponse = await fetch(nextUrl);
    const responseHTML = await _lmResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(responseHTML, 'text/html');
    const newItems = doc.querySelector('.load-more-grid');
    const grid = document.querySelector('.load-more-grid');
    if (newItems && grid) {
      grid.insertAdjacentHTML('beforeend', newItems.innerHTML);
    }
    if (typeof colorSwatches === 'function') colorSwatches();
  } finally {
    if (currentPage <= totalPages) {
      const scrollData = document.querySelector('.infinite-scroll__data');
      if (scrollData && currentPage != totalPages) {
        const nextUrlInput = scrollData.querySelector('input[data-next-url]');
        const currentPageInput = scrollData.querySelector('input[data-current-page]');
        if (nextUrlInput) { nextUrlInput.dataset.nextUrl = nextUrlScroll; nextUrlInput.value = nextUrlScroll; }
        if (currentPageInput) { currentPageInput.dataset.currentPage = currentPage; currentPageInput.value = currentPage; }
        checkVisibility();
      }
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      if (currentPage == totalPages) button.remove();
      setTimeout(() => { isLoading = false; }, 200);
    }
  }
};

const checkVisibility = () => {
  activeObservers.forEach(obs => obs.disconnect());
  activeObservers = [];

  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
    activeObservers.push(sectionObserver);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
